import * as React from 'react';
import * as PropTypes from 'prop-types';

import { IStyleProps, mergeStyles } from '@cian/utils';
import { IOffer } from '../../types/offer';
import { IOfferHelper } from '../../presenter';

import * as styles from './ShowMoreOffers.css';

interface IShowMoreOffersContext {
  offer: IOffer;
  offerHelper: IOfferHelper;
}

interface IShowMoreOffersProps {
  containerStyle?: IStyleProps | string;
}

export class ShowMoreOffers extends React.Component<IShowMoreOffersProps> {
  public context: IShowMoreOffersContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public render() {
    return (
      <a
        href={ this.getShowMoreOffersLink() }
        target="_blank"
        {...mergeStyles(
          styles['other_offers'],
          this.props.containerStyle)
        }
      >
        { this.props.children ? this.props.children : 'Ещё объекты' }
      </a>
    );
  }

  private getShowMoreOffersLink = () => {
    const { offer, offerHelper } = this.context;
    const offerTypeForUserUrl = offerHelper.isCommercial() ? 'offices' : offer.offerType;
    const user = offer.user;
    const masterAgent = user ? user.masterAgent : null;
    const userIdForLink = masterAgent ? masterAgent.id : offerHelper.presenters.getCianUserId();
    const userIdQuery = userIdForLink ? `id_user=${userIdForLink}&` : '';

    return `/cat.php?${userIdQuery}deal_type=${offer.dealType}&${offerTypeForUserUrl}=yes&engine_version=2`;
  }
}
